// 時區集中在這裡。CRM 前端只有兩種時區，名稱別互套：
// - LOCAL_TZ：使用者瀏覽器時區（＝舊版 lib/constants 的 TZ）。列表時間欄、休假起訖、操作日誌、活動模組照舊版用它
// - BIZ_TZ：業務時區＝資料庫與後端 taskTZ。任務截止日、線路列表快照日用它，否則跨日會差一天
// BI 儀表板（美東）、BI 訂閱（倫敦）是另一個專案的業務時區，不在這裡。
import dayjs from 'dayjs'

export const LOCAL_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone
export const BIZ_TZ = 'Asia/Taipei'

// 時間值（ISO、Date、unix 毫秒）→ 該時區的字串
export const fmtLocal = (v, fmt) => dayjs(v).tz(LOCAL_TZ).format(fmt)
export const fmtBiz = (v, fmt) => dayjs(v).tz(BIZ_TZ).format(fmt)

// 現在時間落在該時區
export const nowLocal = () => dayjs().tz(LOCAL_TZ)
export const nowBiz = () => dayjs().tz(BIZ_TZ)

// YYYY-MM-DD → 該時區當日 00:00:00／23:59:59（dayjs 物件，呼叫端自己 .unix() 或 .toISOString()）
export const localDayStart = (date) => dayjs.tz(`${date} 00:00:00`, LOCAL_TZ)
export const localDayEnd = (date) => dayjs.tz(`${date} 23:59:59`, LOCAL_TZ)
export const bizDayStart = (date) => dayjs.tz(`${date} 00:00:00`, BIZ_TZ)
export const bizDayEnd = (date) => dayjs.tz(`${date} 23:59:59`, BIZ_TZ)
